export default __webpack_public_path__ + "static/media/why-img.51965503.png";